import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

export const Line = styled.div`
  border-radius: 2px;
  display: flex;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 15px;
  line-height: 24px;
  padding: 8px 16px;
  margin: 2px 0;
  > :first-child {
    color: var(--section-ebony-light-color, var(--ebony-light));
    font-weight: bold;
    flex: 1 0;
    &.no-invoices {
      font-weight: 600;
    }
  }
  &.no-invoices {
    text-align: center;
    margin: 0;
    padding-bottom: 40px;
  }
  &.billing-period {
    padding: 0 0 8px;
    margin: 0 0 16px 0;
    border-bottom: 1px
      var(--section-periwinkle-grey-border-color, var(--periwinkle-grey));
    a {
      color: var(--link-color-primary-600-color, var(--color-primary-600));
      font-weight: 600;
      text-decoration: none;
    }
  }
  &.trial {
    background-color: var(
      --section-cosmic-latte-background-color,
      var(--cosmic-latte)
    );
    color: var(--banner-ebony-color, var(--ebony));
    > :first-child {
      color: var(--banner-ebony-color, var(--ebony));
    }
  }
  &.subtotal-discount,
  &.base_price {
    background-color: var(--section-ice-background-color, var(--ice));
  }
  &.empty {
    color: var(--header-granite-color, var(--granite));
    font-weight: 600;
    > :first-child {
      color: var(--header-granite-color, var(--granite));
    }
  }
  &.total-row {
    background-color: var(
      --section-color-primary-100-background-color,
      var(--color-primary-100)
    );
    margin: 6px 0 0;
    padding: 16px;
    flex-direction: column;
    > :first-child {
      flex: 0 0;
    }
    h2 {
      line-height: 33px;
      margin-bottom: 0;
      .total-currency {
        margin-left: 7px;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        color: var(--header-granite-color, var(--granite));
      }
    }
    > span {
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: var(--section-slate-color, var(--slate));
    }
  }
`;

export const OrderTotalWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 7px;
`;

export const EmptyAmountTitle = styled(Typography.Title)`
  color: var(--mode-text-neutral-weakest);
`;

export const Loading = styled(LoadingDs)`
  margin: 0 auto;
  display: flex;
`;
